<template>
  <BaseModal
    :id="id"
    :modalClass="`modal-md`"
    :headerText="$t('message.refdoclog')"
    :showCloseButton="false"
    :cancelButtonText="$t('button.cancel')"
    :sumitButtonText="$t('button.save')"
    :isSubmitted="isSubmitted"
    @onCancel="handleCancel"
    @onSubmit="handleSubmit"
  >
    <template #body>
      <div class="container-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t('message.topic') }} *</label>
              <select
                v-model="$v.topic.$model"
                :disabled="isSubmitted || isEdit"
                :class="[{ 'is-invalid': $v.topic.$error }]"
                class="form-control custom-select"
              >
                <option :value="null">{{ $t('placeholder.select') }}</option>
                <option
                  v-for="(topic, index) in filterLogTopics"
                  :key="index"
                  :value="topic.value"
                >
                  {{ topic.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t('message.description') }}</label>
              <textarea
                v-model="$v.description.$model"
                :disabled="isSubmitted"
                class="form-control"
                style="min-height: 52px;"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>{{ $t('message.scheduledate') }}</label>
              <BaseInputDatePicker
                v-model="$v.schedule_date.$model"
                :disabled="isSubmitted"
                mode="dateTime"
                is24hr
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { getMasterDataText } from '../../helpers'

export default {
  props: {
    id: {
      type: String,
      default: null,
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    initialValue: {
      type: Object,
      default: () => ({}),
    },
    logTopics: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      logId: null,
      topic: null,
      description: null,
      schedule_date: null,
    }
  },

  validations: {
    topic: {
      required,
    },
    description: {},
    schedule_date: {},
  },

  computed: {
    isEdit() {
      return this.logId != null
    },
    filterLogTopics() {
      return this.logTopics
        .filter((topic) => topic.is_active)
        .map((topic) => {
          return {
            ...topic,
            value: topic.name,
            text: getMasterDataText(topic.name, this.$t),
          }
        })
    },
  },

  watch: {
    initialValue: {
      handler: function () {
        this.logId = this.initialValue.logId
        this.topic = this.initialValue.topic
        this.description = this.initialValue.description
        this.schedule_date = this.initialValue.schedule_date
      },
      deep: true,
    },
  },

  methods: {
    reset() {
      this.$v.$reset()
      this.logId = null
      this.topic = null
      this.description = null
      this.schedule_date = null
    },
    handleCancel () {
      $(`#${this.id}`).modal('hide')
      this.$emit('onCancel')
      this.reset()
    },
    handleSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const form = {
          logId: this.logId,
          topic: this.topic,
          description: this.description,
          schedule_date: this.schedule_date,
        }
        const callback = this.reset
        this.$emit('onSubmit', form, callback)
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/BaseModalDocRefLog.vue